export var StatusEnum;
(function (StatusEnum) {
    // 通用状态
    StatusEnum[StatusEnum["SUCCESS"] = 0] = "SUCCESS";
    StatusEnum[StatusEnum["FAIL"] = -1] = "FAIL";
    StatusEnum[StatusEnum["RESPONSE_ERROR"] = -2] = "RESPONSE_ERROR";
    StatusEnum[StatusEnum["REQUEST_URL_NOT_VALID"] = -3] = "REQUEST_URL_NOT_VALID";
    StatusEnum[StatusEnum["PARAM_TYPE_NOT_VALID"] = -4] = "PARAM_TYPE_NOT_VALID";
    StatusEnum[StatusEnum["CONFIG_NOT_FOUND"] = -5] = "CONFIG_NOT_FOUND";
    StatusEnum[StatusEnum["FEATURE_NOT_SUPPORT"] = -6] = "FEATURE_NOT_SUPPORT";
    StatusEnum[StatusEnum["NAMESPACE_NOT_VALID"] = -7] = "NAMESPACE_NOT_VALID";
    StatusEnum[StatusEnum["EVENT_HANDLER_EMPTY"] = -8] = "EVENT_HANDLER_EMPTY";
    StatusEnum[StatusEnum["ROUTE_PATTERN_NOT_FOUND"] = -9] = "ROUTE_PATTERN_NOT_FOUND";
    StatusEnum[StatusEnum["PARAM_MISSING"] = -10] = "PARAM_MISSING";
    StatusEnum[StatusEnum["PARAM_NOT_VALID"] = -11] = "PARAM_NOT_VALID";
    StatusEnum[StatusEnum["URL_ROUTE_ERROR"] = -12] = "URL_ROUTE_ERROR";
    StatusEnum[StatusEnum["HTTP_UNAUTHORIZED"] = 401] = "HTTP_UNAUTHORIZED";
    StatusEnum[StatusEnum["HTTP_BAD_REQUEST"] = 400] = "HTTP_BAD_REQUEST";
    StatusEnum[StatusEnum["HTTP_MOVE_PERMANENTLY"] = 301] = "HTTP_MOVE_PERMANENTLY";
})(StatusEnum || (StatusEnum = {}));
